import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { COMMONS_ENV } from '@damofire/data-angular-commons';
import { Division } from '@damofire/data-stas';
import { ObservableSavedSearchService, SavedSearch, Warehouse } from '@damofire/data-watson';
import { TranslatePipe } from '@ngx-translate/core';
import { SubSink } from 'subsink';
import { AutoUnsubscribe } from '../auto-unsubscribe.decorator';
import { DisabledOfflineDirective } from '../directive/disabled-offline.directive';
import { IfOnlineDirective } from '../directive/if-online.directive';
import { ShowOnRepairModeRepairDirective } from '../directive/show-repairs.directive';
import { SavedSearchMenuComponent } from '../saved-search/saved-search-menu/saved-search-menu.component';
import { UserRolePipe } from '../security/user-role.pipe';

@AutoUnsubscribe()
@Component({
  selector: 'app-warehouse-sidebar-menu',
  templateUrl: './warehouse-sidebar-menu.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    AsyncPipe,
    DisabledOfflineDirective,
    IfOnlineDirective,
    ShowOnRepairModeRepairDirective,
    SavedSearchMenuComponent,
    UserRolePipe,
    TranslatePipe,
  ],
})
export class WarehouseSidebarMenuComponent implements OnInit {
  @Input()
  division: Division;

  @ViewChild('issuesSavedSearchMenu')
  issuesSavedSearchMenu: SavedSearchMenuComponent;

  private readonly savedSearchSub = new SubSink();
  savedSearch: SavedSearch;

  readonly storageEnabled = false;
  hasWatsonData = false;
  hasCertificationInfos = false;

  constructor(
    @Inject(COMMONS_ENV) private readonly environment: any,
    protected readonly route?: ActivatedRoute,
    protected readonly observableSavedSearchService?: ObservableSavedSearchService,
  ) {
    this.storageEnabled = environment.appConfig.storage.enabled;
  }

  @Input()
  set warehouse(warehouse: Warehouse) {
    this.hasWatsonData = !!warehouse;
    this.hasCertificationInfos = warehouse?.hasCertificationInfos;
    this.division = warehouse ? { ...warehouse.division, organization: warehouse.organization } : this.division;
  }

  ngOnInit(): void {
    this.route?.queryParams.subscribe(async (params) => {
      if (params['search']) {
        this.savedSearchSub.add(
          this.observableSavedSearchService.get(this.division._id, params['search']).subscribe((s) => {
            if (s?.query) {
              this.savedSearch = s;
            } else {
              this.savedSearch = null;
            }
          }),
        );
      }
    });
  }
}
